import React from 'react';

// child components
import ProfileHeader from '../../../helpers/uiComponents/ProfileHeader';
import { Summary } from './ProfileComponents/ProfileSummary';
import { AccountInformation } from './ProfileComponents/AccountInformation';
import BillingInformation from './ProfileComponents/BillingInformation';
import { Contacts } from './ProfileComponents/Contacts';
import { StoreLocations } from './ProfileComponents/StoreLocations';
import { ConnectedServices } from './ProfileComponents/Credentials';
import InsightManager from './ProfileComponents/InsightManager';
import { Seo } from './ProfileComponents/Seo';
import { Catalogs } from './ProfileComponents/ProductCatalogs';
import { WebsiteInfo } from './ProfileComponents/WebsiteInformation';
import ChangeLog from './ProfileComponents/ChangeLog';
import Franchise from './ProfileComponents/Franchise';
import WebsiteConfig from './ProfileComponents/WebsiteConfiguration';

class RightColumn extends React.Component {
    render() {
        const roles = localStorage.getItem("roles");

        return(
            <div className="column profile-column" id="profile-column">
                {(this.props.currentClient) && (
                    <div className="profile">
                        <ProfileHeader
                            resetProfile={this.props.resetProfile}
                            name={this.props.currentClient.name}
                        />
                        <Summary currentClient={this.props.currentClient} />
                        
                        <div className="profile-form">
                            <AccountInformation 
                                currentClient={this.props.currentClient}
                                getClient={this.props.getClient}
                                updateClient={this.props.updateClient}
                                clients={this.props.clients}
                            />
                            <BillingInformation currentClient={this.props.currentClient} />
                            <Contacts currentClient={this.props.currentClient} />
                            <StoreLocations currentClient={this.props.currentClient} />
                            <Franchise
                                currentClient={this.props.currentClient}
                                getClient={this.props.getClient}
                                updateClient={this.props.updateClient}
                                clients={this.props.clients}
                            />
                            <Catalogs
                                currentClient={this.props.currentClient}
                                clients={this.props.clients}
                                updateClient={this.props.updateClient}
                            />
                            <ConnectedServices currentClient={this.props.currentClient} />
                            <WebsiteConfig
                                currentClient={this.props.currentClient}
                                updateClient={this.props.updateClient}
                                getClient={this.props.getClient}
                            />
                            <Seo
                                currentClient={this.props.currentClient}
                                updateClient={this.props.updateClient}
                            />
                            <WebsiteInfo
                                currentClient={this.props.currentClient}
                                updateClient={this.props.updateClient}
                                roles={roles}
                            />
                            <InsightManager
                                currentClient={this.props.currentClient}
                                getClient={this.props.getClient}
                            />
							{(this.props.currentClient && roles.includes("admin")) && (
								<ChangeLog currentClient={this.props.currentClient} />
							)}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
export default RightColumn;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/Profile.js